import type { VoidFunctionComponent } from 'react';

import type { Dependency } from '../../../../../shared/dependenciesV2';

import DependencyContent from './DependencyContent';
import DependencyDrawerLoader from './DependencyDrawerLoader';
import type { DrawerScope } from './types';

type DependencyDrawerProps = {
  /**
   * A callback that's performed when the drawer's close button is clicked.
   */
  onClose: () => void;
  /**
   * The dependency to display.
   */
  dependency: Dependency | null;
  /**
   * Whether or not we're loading the dependency.
   */
  isLoading: boolean;
  /**
   * The scope that the drawer is being loaded in.
   */
  scope: DrawerScope;
  /**
   * A callback that's performed when a dependency is edited.
   */
  onEditDependency: () => void;
  /**
   * A callback that's performed when a dependency is ignored or deleted.
   */
  onDeleteDependency?: () => void;
};

const DependencyDrawer: VoidFunctionComponent<DependencyDrawerProps> = ({
  dependency,
  isLoading,
  scope,
  onEditDependency,
  onDeleteDependency,
  onClose,
}) => {
  if (isLoading || !dependency) {
    return <DependencyDrawerLoader />;
  }

  return (
    <DependencyContent
      dependency={dependency}
      onEditDependency={onEditDependency}
      onDeleteDependency={onDeleteDependency}
      onClose={onClose}
      scope={scope}
    />
  );
};

export default DependencyDrawer;
